import {SET_ERRORS, DELETE_ERROR_FOR_INPUT, CLEAR_ERRORS} from './types.js';

/**
 * Action creators for errors
 */

// Action for setting errors to store
export function setErrors(errors) {
    return {
        type: SET_ERRORS,
        errors: errors
    };
}

// Action for clearing errors for certain input
export function clearErrorsForInput(inputName) {
    return {
        type: DELETE_ERROR_FOR_INPUT,
        inputName: inputName
    };
}

// Action for clearing all errors
export function clearErrors() {
    return {type: CLEAR_ERRORS};
}


// WEBPACK FOOTER //
// ./src/actions/error.js